/**
 * レスポンシブデザイン用のブレークポイント設定
 * プロジェクト全体で統一されたブレークポイントを管理
 * 
 * 使用方法:
 * import { BREAKPOINTS, useIsMobile, useIsDesktop } from '../config/breakpoints';
 */

import { useState, useEffect } from 'react';

// ブレークポイント定義（ここを変更すると全体に反映される）
export const BREAKPOINTS = {
  // モバイル/SP版の境界線（サイドバー→フッター切り替え）
  MOBILE: 650,
  // デスクトップ版の境界線
  DESKTOP: 1024,
} as const;

/**
 * モバイル判定用のカスタムフック
 * レイアウト切り替えでよく使用される
 */
export const useIsMobile = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth <= BREAKPOINTS.MOBILE;
};

/**
 * デスクトップ判定用のカスタムフック
 * コントローラー表示などでよく使用される
 */
export const useIsDesktop = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth > BREAKPOINTS.MOBILE;
};
